module.exports = __webpack_public_path__ + "static/img/gx.c6f4542.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s30/gx.png
// module id = cv/u
// module chunks = 2